import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ImagesModeProps = IconComponentBaseProps;

export const ImagesMode = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ImagesModeProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_9334_204878"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9334_204878)">
        <path
          d="M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM7.654 16.75H16.423C16.6038 16.75 16.7378 16.6679 16.825 16.5038C16.9122 16.3398 16.8987 16.1808 16.7845 16.027L14.4 12.8328C14.3063 12.7123 14.1858 12.652 14.0385 12.652C13.891 12.652 13.7705 12.7123 13.677 12.8328L11.2308 16.0192L9.59225 13.9192C9.49875 13.8051 9.37983 13.748 9.2355 13.748C9.09133 13.748 8.97242 13.8083 8.87875 13.929L7.302 16.027C7.1815 16.1808 7.16483 16.3398 7.252 16.5038C7.33917 16.6679 7.47317 16.75 7.654 16.75ZM8.5 9.75C8.84617 9.75 9.141 9.62817 9.3845 9.3845C9.62817 9.141 9.75 8.84617 9.75 8.5C9.75 8.15383 9.62817 7.859 9.3845 7.6155C9.141 7.37183 8.84617 7.25 8.5 7.25C8.15383 7.25 7.859 7.37183 7.6155 7.6155C7.37183 7.859 7.25 8.15383 7.25 8.5C7.25 8.84617 7.37183 9.141 7.6155 9.3845C7.859 9.62817 8.15383 9.75 8.5 9.75Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
